module.exports = __webpack_public_path__ + "img/man_jump_crm_login_light_2.390aeabd.jpg";